import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import QuestionSetForm from '../../../components/forms/QuestionSetForm';
import { useQuestionSetApi } from '../../../hooks/useQuestionSetApi';
import { useNavigate, useParams } from 'react-router-dom';
import { QuestionSetDTO } from '../../../services/apiClient';

const QuestionSetEdit: React.FC = () => {
  const { getById, edit, isLoading } = useQuestionSetApi();
  const [entityData, setEntityData] = useState<QuestionSetDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Question Sets', href: '/admin/questionsets' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching QuestionSet data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/questionsets');
    } catch (error) {
      console.error('Error updating QuestionSet:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/questionsets"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Content.QuestionSet.Edit'
    >
        {entityData ? (
          <QuestionSetForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/questionsets')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default QuestionSetEdit;